import { createQueryFilters } from 'context/DataContext';
import useTableQueryParams from 'hooks/useTableQueryParams';

import { useQuery } from '@apollo/client';

import {
  AssetClass,
  Filter,
  FilterableField,
  FilterOperator,
  SortableField,
  SortDirection,
} from '__generated__/globalTypes';
import { GetDrilldown, GetDrilldownVariables } from 'query/__generated__/drilldown';
import { GET_DRILLDOWN_QUERY } from 'query/drilldown';
const getDrilldownVariables = (
  assetClass: AssetClass | null,
  filters: Filter[],
  sorting: { id: SortableField; desc: boolean }[],
): GetDrilldownVariables => {
  const queryFilters = createQueryFilters(assetClass, filters);
  return {
    sort: {
      sort_field: sorting[0]?.id,
      sort_direction: sorting[0]?.desc ? SortDirection.desc : SortDirection.asc,
    },
    pagination: {},
    filters: queryFilters,
  };
};

export const usePortfolioLoans = (
  gqlAssetClass: AssetClass | null,
  queryFilters: Filter[],
  loansSorting: { id: SortableField; desc: boolean }[],
) => {
  const { params, updateParams } = useTableQueryParams();
  const { data, loading, previousData } = useQuery<GetDrilldown, GetDrilldownVariables>(
    GET_DRILLDOWN_QUERY,
    {
      variables: {
        ...getDrilldownVariables(gqlAssetClass, queryFilters, loansSorting),
        pagination: {
          offset: (params.pageNumber - 1) * params.pageSize,
          page_size: params.pageSize,
        },
      },
      skip: !gqlAssetClass,
      fetchPolicy: 'no-cache',
    },
  );

  return {
    data: data,
    // gqlAssetClass === AssetClass.CRE
    //   ? {
    //       user: {
    //         company: { loans: mock_cre },
    //         performanceData: { loanCount: 4 },
    //         unlistedLoansPerformanceData: { loanCount: null },
    //       },
    //     }
    //   : data,
    loading,
    previousData,
    params,
    updateParams,
  };
};
